module.exports = __webpack_public_path__ + "img/GAME_OILPAINT.02f5dc0a.jpg";